import { render, staticRenderFns } from "./AceptarInformacion.vue?vue&type=template&id=7837c864&"
import script from "./AceptarInformacion.vue?vue&type=script&lang=ts&"
export * from "./AceptarInformacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports